import { render, staticRenderFns } from "./ReplySend.vue?vue&type=template&id=4c55e3f2&scoped=true&"
import script from "./ReplySend.vue?vue&type=script&lang=js&"
export * from "./ReplySend.vue?vue&type=script&lang=js&"
import style0 from "./ReplySend.vue?vue&type=style&index=0&id=4c55e3f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c55e3f2",
  null
  
)

export default component.exports